import React from 'react';
import { Size, useWindowSize } from '../../hook/useWindowSize';
import BusinessButton from '../business-button/business-button';
import { IconType } from '../icons';
import styles from './back-to-latest-article.module.scss';
interface Props {
    latestArticleUrl: string;
}

const BackToLatestArticle: React.FC<Props> = (props: Props) => {
    const { latestArticleUrl } = props;
    const windowSize: Size = useWindowSize();
    const isMobile = (): boolean => {
        const windowWidth: number = windowSize.width || 0;
        if (windowWidth < 768) {
            return true;
        } else {
            return false;
        }
    };

    // TODO standardise where latest articles page is.

    return (
        <a href={latestArticleUrl} target="_self" className={styles.backToLatestArticle}>
            <BusinessButton size={isMobile() ? 'small' : 'normal'} color="white" buttonText="Back to access" icon={IconType.ArrowRightMedium} />
        </a>
    );
};
export default BackToLatestArticle;
